export default __webpack_public_path__ + "static/media/Idle (3).2e9d8994.png";